import api from "./api";

export async function loader({ params }) {
  const id = params.id;
  const response = await api.get(`/record/${id}`);
  return response.data;
}
